module.exports = __webpack_public_path__ + "media/images/duel/confetti-right-de36a7b11004fc45b3d4dde643f5a775.svg";